import { useRef, useState } from "react";
import Confirm from "../Modal/Confirm";
import Loading from "../Modal/Loading";
import { deleteOperationByPartLink } from "../../api/calculator/calculatorServices";
function CalculatorOperationsList(props) {
  const { operations, getOperations } = props;
  const [message, setMessage] = useState("");
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [show, setShow] = useState(false);
  const [iconToShow, setIconToShow] = useState("");
  const functionCaller = useRef(() => {
  });
  const styles = `
    /* ====== Visual tokens (tuned to match the screenshot) ====== */
      :root {
        --bg: #0b0d0e; /* page */
        --chrome: #262c31; /* top bar */
        --panel: #0f1011; /* main black surface */
        --panel-edge: #111315; /* inner border */
        --text: #d3d8de; /* title text */
        --date: #1db354; /* bright green date */

        --icon-hole: #0a0a0a; /* triangle color */
        --calc: #f4c01a; /* yellow calc button */
        --muted: #a7b0b8;
        --radius-outer: 14px;
        --radius-inner: 10px;
        --shadow-outer: 0 10px 24px rgba(0, 0, 0, 0.45);
        --shadow-inset: inset 0 0 0 1px rgba(255, 255, 255, 0.06);
      }

      * {
        box-sizing: border-box;
      }
      html,
      body {
        height: 100%;
      }
      html {
        padding: 0 !important;
      }
      body {
        margin: 0;
        overflow-x: hidden;
      }
      .content-list-calculator {
        min-width: 100vw;
        min-height: 100vh;
        margin: 0;
        background: var(--bg);
        color: var(--text);
        display:flex;
        flex-direction: column;
        align-items: center;
        overflow-x: hidden;
      }

      .card {
        margin-top:10px;
        width: 800px;
        border-radius: var(--radius-outer);
        overflow: hidden;
        box-shadow: var(--shadow-outer);
        border: 1px solid #1a1f23;
        background:transparent;
      }

      /* ====== TOP BAR ====== */
      .topbar {
        background: var(--chrome);
        padding: 16px 18px;
        display: grid;
        grid-template-columns: auto;
        align-items: center;
        
      }
      .date {
        color: var(--date);
        font-weight: 800;
        font-size: 30px;
        letter-spacing: 0.3px;
        text-shadow: 0 1px 0 rgba(0, 0, 0, 0.35);
      }
      .t-title {
        color: var(--text);
        font-weight: 800;
        font-size: 34px;
        letter-spacing: 0.2px;
        opacity: 0.92;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .sub-title{
      color: var(--text);
      }
      /* buttons */
      .actions {
        display: flex;
        gap: 12px;
      }
      .btn-square {
        width: 50px;
        height: 50px;
        border-radius: 12px;
        display: grid;
        place-items: center;
        box-shadow: var(--shadow-outer), var(--shadow-inset);
        border: 2px solid rgba(0, 0, 0, 0.35);
      }
      .btn-warn {
        background: var(--calc);
      }
      .icon {
        width: 26px;
        height: 26px;
        color: #1b1b1b;
      }

      /* ====== WORKSPACE ====== */
      .workspace {
        display: grid;
        grid-template-columns: 1fr;
        min-height: 200px;
        background: var(--panel);
      }
      .board {
        position: relative;
        border-top: 1px solid #0a0c0d;
        border-bottom: 1px solid #0a0c0d;
        border-left: 1px solid #2a2f33;
        padding: 48px 24px;
        display: grid;
        place-items: center;
      }

      .board h2 {
        margin: 0;
        font-size: 28px;
        color: #e7edf2;
        font-weight: 700;
      }

      .play {
        width: 56px;
        height: 56px;
        border-radius: 14px;
        background: rgba(255, 255, 255, 0.12);
        display: grid;
        place-items: center;
        box-shadow: var(--shadow-inset), 0 6px 16px rgba(0, 0, 0, 0.35);
      }

      /* Small viewports */
      @media (max-width: 820px) {
        .card {
          width: 99vw;
          border-radius: var(--radius-outer);
          overflow: hidden;
          box-shadow: var(--shadow-outer);
          border: 1px solid #1a1f23;
        }
      }

      @media (max-width: 720px) {
        .t-title {
          font-size: 24px;
        }
        .date {
          font-size: 22px;
        }
      }
  `;
  const handleOpenCalculatorEditor = (value) => {
    const windowName = "";
    window.open(`/bonus/calculator/${value}/edit`, windowName);
  };
  const handleOpenCalculator = (value) => {
    const windowName = "";
    const windowFeatures = "width=1000,height=660";
    window.open(`/bonus/calculator/${value}`, windowName, windowFeatures);
  };
  function handleDelete() {
    setMessage(
      "Deseja realmente prosseguir? A exclus\xE3o da calculadora n\xE3o pode ser desfeita."
    );
    setShow(true);
  }
  async function deleteCalculator(idUrlPath) {
    setShowLoadingModal(true);
    setIconToShow("loading");
    setMessage(
      "Aguarde um momento enquanto a calculadora est\xE1 sendo removida."
    );
    const res = await deleteOperationByPartLink(idUrlPath);
    if (res.ok) {
      getOperations();
      setIconToShow("success");
      setMessage("Pronto! A calculadora foi removida com sucesso.");
    } else {
      setIconToShow("error");
      setMessage(res.message);
    }
  }
  const openCalculatorCreator = () => {
    const windowFeatures = "width=1000,height=660";
    window.open(`/bonus/creator/calculator/`, "", windowFeatures);
  };
  return (
    <div className="content-list-calculator">
      {/* Injeta o CSS localmente para manter o componente auto-contido */}
      <style dangerouslySetInnerHTML={{ __html: styles }} />

      <div className="card" role="region">
        <div className="topbar">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="text-light fs-3 fw-bold">Criar Calculadora</div>
            <button
              type="button"
              className="btn btn-primary fs-3 fw-bold py-0 px-3 m-0"
              onClick={()=>{openCalculatorCreator();}}
            >
              +
            </button>
          </div>
        </div>
      </div>

      {operations.map((item, index) => {
        return (
          <div
            className="card"
            role="region"
            aria-label={item.time_expiration}
            key={index}
          >
            <div className="topbar">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div className="date">{item.time_expiration}</div>
                <div className="actions">
                  {/* Calculator button */}
                  <button
                    className="btn btn-warning"
                    aria-label="Abrir calculadora"
                    onClick={() => {
                      handleOpenCalculatorEditor(item.part_link);
                    }}
                  >
                    <svg
                      className="icon icon-dark"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <rect
                        x="4"
                        y="3"
                        width="16"
                        height="18"
                        rx="3"
                        ry="3"
                      ></rect>
                      <rect
                        x="7"
                        y="6"
                        width="10"
                        height="3"
                        fill="#e8e8e8"
                      ></rect>
                      <g fill="#e8e8e8">
                        <rect x="7" y="11" width="3" height="3" />
                        <rect x="11" y="11" width="3" height="3" />
                        <rect x="15" y="11" width="3" height="3" />
                        <rect x="7" y="15" width="3" height="3" />
                        <rect x="11" y="15" width="3" height="3" />
                        <rect x="15" y="15" width="3" height="3" />
                      </g>
                    </svg>
                  </button>
                  {/* Trash button */}
                  <button
                    className="btn btn-danger"
                    aria-label="Excluir"
                    onClick={() => {
                      functionCaller.current = () => {
                        deleteCalculator(item.part_link);
                      };
                      handleDelete();
                    }}
                  >
                    <svg
                      className="icon icon-dark"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M9 3h6l1 2h4v2H4V5h4l1-2zM6 9h12l-1 10a3 3 0 0 1-3 3H10a3 3 0 0 1-3-3L6 9z"></path>
                    </svg>
                  </button>
                </div>
              </div>
              <div className="t-title">{item.title}</div>

              <small className="fw-light fs-5 sub-title">
                {item.sub_title}
              </small>
            </div>

            <div className="workspace">
              <div className="board">
                <a
                  href={`/bonus/calculator/${item.part_link}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => {
                    e.preventDefault();
                    handleOpenCalculator(item.part_link);
                  }}
                  className="fs-3 link-primary text-docration-none text-decoration-underline"
                >
                  Link da Calculadora
                </a>
              </div>
            </div>
          </div>
        );
      })}

      <Confirm
        messageModal={message}
        show={show}
        setShow={setShow}
        processData={functionCaller.current}
      />

      <Loading
        messageModal={message}
        show={showLoadingModal}
        setShow={setShowLoadingModal}
        iconToShow={iconToShow}
      />
    </div>
  );
}
export {
  CalculatorOperationsList as default
};